<template>
    <div class="background_color">
        <div  class="container-fluid">
          
      <br>
        <div class="row top-mrgg1">
          <div class="col-md-6 ">
              <div class="left-mrgg1 mt-4">
              <img class="mb-2" src="../../assets/evenware-logo.png" width="140" alt="">
              <h6 style="font-size: large;">{{details[144]['Welcome to Municipality Fault-reporting & Contractor tracking system']}} </h6>
              <p style="font-size: x-small;">
                {{details[98]['Warning']}} : {{details[126]['All users of this system are traceable and any unauthorised usage is prohibited']}}.
              </p>
              </div>
          </div>
          <div  class="col-md-6 margin2">
            <div class="bdr1 card bdr-rad2">
              <p class="authorization bdr-rad">{{details[96]['Authorization']}}</p>

              <div class="">
                <input v-model="login.username" :placeholder="details[60]['Username']" class="form-control input5 input6 bdr-rad">
                <input type="password" v-model="login.password" :placeholder="details[94]['Password']" class="form-control input5 bdr-rad">
                
               
                <b-button v-on:click="Login()" style="background-color: #1b2753;color: white;" class="btn  login1 bdr-rad">{{details[95]['Login']}}</b-button>
                
              </div>
            </div>
          </div>
     
        </div>
    </div>

        <ContentFooter2></ContentFooter2>
    </div>
</template>
<script>
  import ContentFooter2 from './../../layout/ContentFooter2.vue'
  import authService from './../../auth.service';
  import axios from 'axios';
  import httpClient from '@/axios';

  export default  {
    data(){
return {
    errors:'',
    errors2:'',
    details:[],
    'login':{
              'username':'',
              'password':'',
            }
}
    },

    
    created(){
      this.loadlanguage();
    },
    components:{
        ContentFooter2

    },
    methods: {


      async loadlanguage() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/user/loadlanguage',{
        headers:{
          // 'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.details = data.details;
      
       console.log(this.details);
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


        async  Login() {
      // console.log("here we are",this.errorlist); check karaganimata awashya we
       console.log(this.login);
       const {success,errors,errors2} = await authService.Login(this.login);
       if(success==1){
        this.$router.push('/issuetracking/index');
        window.location.reload();
       }else if(success==2){
        this.$router.push('/issuetracking/contractor');
        window.location.reload();
       }
       else{
        this.errors = errors;
        this.errors2 = errors2;
       }
       
       
          
          
      //      //window.location.reload();
          
        
        
   

    },

    },





  }
</script>
<style scoped>
.btn {
    border-width: 0px;
}
input::placeholder {
  color: gray;
}

.form-control {
    height:40%;
}


@media only screen and (min-width: 768px) {
  .left-mrgg1{
  margin-left: 30%;
  
}
.top-mrgg1{
  margin-top: 140px
}


.bdr1{
  padding: 30px 10px 60px 10px;
  width: 408px;
  margin-left: 7%;
}
.login1{
  width: 365px;
  font-size: small;
  margin-left: 8px;
  margin-top: 14px;
}
.input5{
  width: 365px;
  font-size: small;
  margin-left: 8px;
  margin-top: 8px;
 
}
.input6{
  margin-top: 25px;
}
.authorization{
  background-color: #f5f5f5;
  width: 380px;
  padding: 5px;
  padding-left: 15px;
  color: #1b2753;

}

}







@media only screen and (max-width: 768px) {

.left-mrgg1{
  text-align: center;
}

.bdr1{
  padding: 30px 10px 50px 10px;
  width: 340px;
  margin: 0 auto;
}

.login1{
  width: 300px;
  font-size: small;
  margin-left: 8px;
  margin-top: 14px;
}

.input5{
  width: 300px;
  font-size: small;
  margin-left: 8px;
  margin-top: 8px;
}

.input6{
  margin-top: 25px;
}

.authorization{
  background-color: #f5f5f5;
  width: 315px;
  padding: 5px;
  padding-left: 15px;
  border-radius: 4px;
}

}









</style>